import React, { useState } from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const { t } = useLocale();

  const faqs = [
    {
      question: t('eunoiaFAQ1Question'),
      answer: t('eunoiaFAQ1Answer')
    },
    {
      question: t('eunoiaFAQ2Question'),
      answer: t('eunoiaFAQ2Answer')
    },
    {
      question: t('eunoiaFAQ3Question'),
      answer: t('eunoiaFAQ3Answer')
    },
    {
      question: t('eunoiaFAQ4Question'),
      answer: t('eunoiaFAQ4Answer')
    }
  ];

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <h2>{t('faqTitle')}</h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleAccordion(index)}
                style={{
                  alignItems: 'center',
                  fontSize: '16px',
                  fontWeight: 500,
                }}
              >
                <span>{faq.question}</span>
                <i className={`fas fa-chevron-${activeIndex === index ? 'up' : 'down'}`}></i>
              </button>
              <div className="faq-answer" style={{ maxHeight: activeIndex === index ? '200px' : '0' }}>
                <div className="faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;